<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>


        <div class="container-fluid mt--7">
            <div class="row">

                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">My Applications</h3>
                                </div>
                                <!-- <div class="col-4 text-right">
                                    <a href="#!" class="btn btn-sm btn-primary">Settings</a>
                                </div> -->
                            </div>
                        </div>

                        <template>
                            <tabs fill class="flex-column flex-md-row">
                                <card shadow>
                                    <tab-pane 
                                        title="CPD Re-accreditation"
                                        @tab-activated="triggerReAccreditationApplications"
                                    >
                                        <span slot="title">
                                            <i class="ni ni-archive-2"></i>
                                            CPD Re-accreditation
                                        </span>
                                        <!-- CPD Applications template here -->
                                        <CpdApplications 
                                            :type="'re-accreditation'"
                                            ref="callReApplications"
                                        />
                                    </tab-pane>

                                    <tab-pane 
                                        title="Visitation Applications"
                                        @tab-activated="triggerVisitationApplications"
                                    >
                                        <span slot="title">
                                            <i class="ni ni-collection"></i>
                                            Visitation Applications
                                        </span>
                                        <!-- Visitation Applications template here -->
                                        <CpdApplications 
                                            :type="'visitation'"
                                            ref="callVisitationApplications"
                                        />
                                    </tab-pane>

                                    <tab-pane 
                                        title="CPD Applications"
                                        @tab-activated="triggerCpdApplications"
                                    >
                                        <span slot="title">
                                            <i class="ni ni-books"></i>
                                            CPD Applications
                                        </span>
                                        <!-- CPD Applications template here -->
                                        <CpdApplications 
                                            :type="'application'"
                                            ref="callCpdApplications"
                                        />
                                    </tab-pane>
                                </card>
                            </tabs>

                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CpdApplications from './CpdApplications.vue';

    export default {
        components: {
            CpdApplications
        },
        name: 'Applications',
        methods: {
            triggerReAccreditationApplications() {
                if (this.$refs.callReApplications && this.$refs.callReApplications.loadApplications) {
                    this.$refs.callReApplications.loadApplications();
                }
            },
            triggerVisitationApplications() {
                if (this.$refs.callVisitationApplications && this.$refs.callVisitationApplications.loadApplications) {
                    this.$refs.callVisitationApplications.loadApplications();
                }
            },
            triggerCpdApplications() {
                if (this.$refs.callCpdApplications && this.$refs.callCpdApplications.loadApplications) {
                    this.$refs.callCpdApplications.loadApplications();
                }
            },
        }
    };
</script>
<style scoped>
    .width600 {
        width: 600px !important;
    }
    .marginLeft23 {
        margin-left: 23px;
    }
    .image-size {
        height: 180px;
        width: 190px;
    }
</style>
